// Module
var code = `<div class="events-panel">
    <div class="events-panel-container-top">
        <rangeSelectPanel name='eventsRangeSelect' />
        <terceraButton 
                        name="viewMoreHorizontal" 
                        SVG="true" 
                        on-btnClick="filterShowContextMenu" 
                        tooltip="{{filterBtnTooltip}}" 
                        terceraButtonStyle="js-more-button"
                        canCheck="true"
                        checked="{{isFilterMenuShown}}"/>
    </div>

    <div class="events-panel-container-table">
        <terceraPanel name='windowPanelBodyQT' />
    </div>
</div>`;
// Exports
export default code;